import React from 'react';

interface Props {
  contentDescription: string;
  instructionDescription: string;
}

const Title = (props: Props) => {
  
  return (
    <div className="main-content mt-5 px-0">
      <h2 className="content-title font-header-light text-4xl mb-1">{props.contentDescription}</h2>
      <p className="instruction text-sm text-slate">{props.instructionDescription}</p>
    </div>
  )
}

export default Title;
